module.exports = __webpack_public_path__ + "assets/Logo-43b671.svg";